import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "Form" }

import { PropType } from "vue";
import { FormConfig, FormValue } from "@/types";
import FormSection from "@/components/ds/form/FormSection.vue";


export default /*#__PURE__*/_defineComponent({
  ...{
    name: "inn-form",
},
  __name: 'Form',
  props: {
    config: {
        type: Object as PropType<FormConfig>,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.config.sections, (section, index) => {
      return (_openBlock(), _createBlock(FormSection, {
        key: index,
        section: section,
        value: __props.value
      }, null, 8, ["section", "value"]))
    }), 128))
  ]))
}
}

})